import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Grid2, Tab, Tabs } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchFilter from "../../components/common/SearchFilter";
import { tabOptions } from "../../data/PackageListing";
import PackageListingTable from "../../components/PackageListing/PackageListingTable";
import { deleteAllStorageValue, getStorageValue } from "../../utils/helper";
import { ReactComponent as AllPackage } from "../../assets/logos/all_packages.svg";
import { ReactComponent as UnAssigned } from "../../assets/logos/unassigned.svg";
import { ReactComponent as Assigned } from "../../assets/logos/assigned.svg";
import { ReactComponent as Delivered } from "../../assets/logos/delivered.svg";
import { ReactComponent as Intransit } from "../../assets/logos/in-transit.svg";
import { ReactComponent as Expired } from "../../assets/logos/expired.svg";
import PackageListings from "../../utils/services/PackageListing.api";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as AllPackageActive } from "../../assets/logos/all_packages_active.svg";
import { ReactComponent as UnAssignedActive } from "../../assets/logos/unassigned_active.svg";
import { ReactComponent as AssignedActive } from "../../assets/logos/assigned_active.svg";
import { ReactComponent as DeliveredActive } from "../../assets/logos/delivered_active.svg";
import { ReactComponent as IntransitActive } from "../../assets/logos/in-transit_active.svg";
import { ReactComponent as ExpiredActive } from "../../assets/logos/expired_active.svg";

function CustomTabPanel(props) {
  const { children, value, index } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const PackageListingPage = () => {
  const location = useLocation();
  const [tabValue, setTabValue] = useState(
    localStorage.getItem("package:tab") | 0
  );
  const [countData, setCountData] = useState({});
  const iconList = [
    <AllPackage />,
    <UnAssigned />,
    <Assigned />,
    <Intransit />,
    <Delivered />,
    <Expired />,
  ];
  const activeIconList = [
    <AllPackageActive />,
    <UnAssignedActive />,
    <AssignedActive />,
    <IntransitActive />,
    <DeliveredActive />,
    <ExpiredActive />,
  ];
  const roleId = getStorageValue("roleId");
  const navigate = useNavigate();
  const CurrentLatitude = getStorageValue("latitude");

  // API Call to get Table data Count
  const getListingDataCount = async () => {
    const response = await PackageListings.getPackageListingCount(roleId);
    if (response.status === "success") {
      setCountData([
        Object.values(response.data).reduce((acc, ele) => acc + ele),
        response.data.unassigned,
        response.data.assigned,
        response.data.intransit,
        response.data.delivered,
        response.data.expired,
      ]);
    }
  };

  useEffect(() => {
    if (
      localStorage.getItem("notifications") === "true" &&
      localStorage.getItem("isReload") === "true" &&
      localStorage.getItem("isClicked") !== "true"
    ) {
      window?.location?.reload();
      localStorage.removeItem("isReload");
    }
    // eslint-disable-next-line
  }, [localStorage.getItem("notifications")]);

  useEffect(() => {
    getListingDataCount();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (location?.state?.status) {
      setTabValue(location.state.status);
      deleteAllStorageValue("PageNumber");
    }
    // eslint-disable-next-line
  }, [location]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    localStorage.setItem("package:tab", newValue);
    deleteAllStorageValue("PageNumber");
    getListingDataCount();
  };

  const handleDeleteSuccess = () => {
    getListingDataCount();
  };
  return (
    <>
      <Box>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h5" fontWeight={500} fontSize={24}>
            Packages
          </Typography>
          <Button
            style={{ textTransform: "none", backgroundColor: "#0C68F4" }}
            variant="contained"
            size="medium"
            startIcon={<AddIcon />}
            onClick={() => {
              navigate("/create-package", {
                state: { backURL: "/dashboard", status: tabValue },
              });
            }}
          >
            Create New
          </Button>
        </Box>
      </Box>
      {/* tabs */}
      <Grid2 sx={{ marginTop: "5px" }}>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              className="tab-img"
            >
              {tabOptions.map((ele, idx) => {
                return (
                  <Tab
                    sx={{
                      textTransform: "none",
                      fontSize: "14px",
                      color: "#7C8DB5",
                      minHeight: '50px'
                    }}
                    iconPosition="start"
                    icon={
                      idx === tabValue ? activeIconList[idx] : iconList[idx]
                    }
                    label={
                      <>
                        <span
                          style={{
                            color: idx === tabValue ? "black" : "#7C8DB5",
                          }}
                        >
                          {" "}
                          {ele}{" "}
                        </span>{" "}
                        (
                        <span style={{ fontWeight: "500px" }}>
                          {countData[idx] !== undefined ? countData[idx] : 0}
                        </span>
                        )
                      </>
                    }
                  />
                );
              })}
            </Tabs>
          </Box>

          {tabOptions.map((ele, idx) => {
            return (
              <CustomTabPanel key={ele + "Id"} value={tabValue} index={idx}>
                <SearchFilter
                  childComponent={
                    <PackageListingTable
                      type={idx}
                      onDeleteSuccess={handleDeleteSuccess}
                    />
                  }
                  filterCondition={true}
                  typeId={idx}
                  searchPage="package"
                  defaultValue="1"
                  defaultFilterValue={CurrentLatitude ? "250" : "All"}
                />
              </CustomTabPanel>
            );
          })}
        </Box>
      </Grid2>
    </>
  );
};

export default PackageListingPage;
